<template>
  <div ref="container" class="sortable-animated-list">
    <div
      v-for="(item, index) in items"
      :key="itemKey(item, index)"
      class=""
      :class="{}"
      data-draggable-item
      @touchstart="onHoldStart(index, $event)"
    >
      <slot :item="item" :index="index" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SortableList',
  props: {
    items: {
      type: Array,
      required: true
    },
    itemKey: {
      type: Function,
      default: (item, index) => index
    }
  },
  data() {
    return {
      sortable: null,
      cdnLoaded: false
    };
  },
  async mounted() {
    await this.loadSortableCDN();
    this.initSortable();
  },
  beforeUnmount() {
    if (this.sortable) this.sortable.destroy();
  },
  methods: {
    async loadSortableCDN() {
      if (window.Sortable) {
        this.cdnLoaded = true;
        return;
      }
      if (!document.getElementById('sortablejs-cdn')) {
        const script = document.createElement('script');
        script.id = 'sortablejs-cdn';
        script.src =
          'https://cdn.jsdelivr.net/npm/sortablejs@1.15.2/Sortable.min.js';
        script.async = true;
        document.head.appendChild(script);
        await new Promise((resolve) => {
          script.onload = resolve;
        });
      }
      this.cdnLoaded = true;
    },
    initSortable() {
      if (!this.cdnLoaded || !window.Sortable) return;
      if (this.sortable) this.sortable.destroy();
      this.sortable = new window.Sortable(this.$refs.container, {
        animation: 250, // ms, pour une animation fluide
        draggable: '[data-draggable-item]',
        ghostClass: 'opacity-10!',
        chosenClass: ['drop-shadow-xl', 'opacity-100'],

        delay: 150,
        delayOnTouchOnly: true,
        onEnd: (evt) => {
          const oldIndex = evt.oldIndex;
          const newIndex = evt.newIndex;
          if (oldIndex === newIndex) return;
          const newArr = [...this.items];
          const [moved] = newArr.splice(oldIndex, 1);
          newArr.splice(newIndex, 0, moved);
          this.$emit('table-update', newArr);
        }
      });
    },
    onHoldStart(index, event) {
      // event.preventDefault();
    }
  },
  updated() {
    // Réinitialise sortable si items changent
    this.initSortable();
  }
};
</script>
